import React from "react";
import { useLang } from "@/i18n";
import { useCursor } from "@/context/CursorContext";

export const Footer = ({ onNavigate }) => {
  const { t } = useLang();
  const { setCursor, reset } = useCursor();
  const year = new Date().getFullYear();
  const socials = [
    { label: "Instagram", href: "https://www.instagram.com/polatpala_/" },
    { label: "Behance", href: "https://www.behance.net/polatpala" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/polat-pala-52a9b41a0/" },
  ];

  const linkHover = { onMouseEnter: () => setCursor("link"), onMouseLeave: reset };

  return (
    <footer className="border-t border-border bg-void" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div className="tighter leading-[0.9]">
            <h3 className="font-display text-4xl md:text-5xl font-bold uppercase text-bone leading-[0.9]">
              Polat Pala
            </h3>
            <div className="flex flex-col">
              {["Motion", "Video", "Graphic"].map((w) => (
                <span
                  key={w}
                  className="font-display text-4xl md:text-5xl font-normal uppercase text-bone/45 leading-[0.9]"
                >
                  {w}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-start md:items-end text-left md:text-right tighter leading-[0.9]">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                {...linkHover}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="font-display text-4xl md:text-5xl font-bold uppercase text-bone/50 hover:text-navy-ink leading-[0.9] transition-colors duration-300"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 items-center gap-4 border-t border-border pt-8">
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-bone/30 text-center md:text-left">
            © {year} Polat Pala — {t.footer.rights}
          </span>

          <div className="flex justify-center">
            <button
              {...linkHover}
              onClick={() => onNavigate && onNavigate("top")}
              data-testid="back-to-top"
              className="group flex items-center gap-3 font-display text-2xl md:text-3xl font-normal uppercase tighter leading-[0.9] text-bone/60 hover:text-bone transition-colors duration-300"
            >
              <span className="transition-transform duration-300 group-hover:-translate-y-1">↑</span>
              {t.footer.backToTop}
            </button>
          </div>

          <span className="hidden md:block" />
        </div>
      </div>
    </footer>
  );
};
